import * as Actions from '../actionsgazeta';

const initialState = {};

const comunicado = function (state = initialState, action) {
    switch (action.type) {
        case Actions.SET_COMUNICADO_DATA:
            {
                return action.payload

            }
        case Actions.CLEAR_COMUNICADO_DATA:
            {
                return state;
            }
        default:
            {
                return state
            }
    }
};

export default comunicado;
